import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import api from "../services/api.service";
import * as Styles from "../styles/UpdateCustomerAddress.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";
import { AddressAutocomplete } from "./AddressAutocomplete";
import { z } from "zod";

const UpdateCustomerAddressModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  searchValueInput: string;
  setSearchValueInput: (value: string) => void;
  customerAddressToUpdate: any;
  setCustomerInfoByOrder: (value: any) => void;
}> = ({
  isOpen,
  onRequestClose,
  setSearchValueInput,
  customerAddressToUpdate,
  setCustomerInfoByOrder,
}) => {
    const [error, setError] = useState<any>({});
    const {
      setSubsidiaryDataZustand,
      subsidiaryDataZustand,
      setMessageZustand,
    } = useCombinedStore((state) => {
      return {
        setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
        subsidiaryDataZustand: state.subsidiaryDataZustand,
        setOrderDataZustand: state.setOrderDataZustand,
        orderDataZustand: state.orderDataZustand,
        setMessageZustand: state.setMessageZustand,
      };
    });
    const customerPhoneInputRef = useRef<HTMLInputElement>(null);
    const customerNameInputRef = useRef<HTMLInputElement>(null);
    const customerAddressInputRef = useRef<HTMLInputElement>(null);
    const customerAddressComplementInputRef = useRef<HTMLInputElement>(null);
    const customerAddressObservationInputRef = useRef<HTMLInputElement>(null);
    const customerOriginInputRef = useRef<HTMLSelectElement>(null);
    const modalWrapperRef = useRef<HTMLDivElement>(null);

    const [CustomerPhone, setCustomerPhone] = useState<string>("");
    const [CustomerName, setCustomerName] = useState<string>("");
    const [CustomerNewAddress, setCustomerNewAddress] = useState({
      placeId: "",
      formattedAddress: "",
    });
    const [CustomerAddress, setCustomerAddress] = useState<string>("");
    const [CustomerAddressComplement, setCustomerAddressComplement] =
      useState<string>("");
    const [CustomerAddressObservation, setCustomerAddressObservation] =
      useState<string>("");
    const [CustomerOrigin, setCustomerOrigin] = useState("");
    //criar campo dropdown com as origens (aplicativo interno, externo...)
    const [isSubmitting, setIsSubmitting] = useState(false); // Controla a submissão

    useEffect(() => {
      if (isOpen) {
        setCustomerPhone(customerAddressToUpdate.customerPhone);
        setCustomerName(customerAddressToUpdate.customerName);
        // setCustomerNewAddress({
        //   placeId: customerAddressToUpdate.customerPlaceId,
        //   formattedAddress: customerAddressToUpdate.customerFormattedAddress,
        // });
        setCustomerAddress(customerAddressToUpdate.customerAddress);
        setCustomerAddressComplement(customerAddressToUpdate.customerAddressComplement);
        setCustomerAddressObservation(customerAddressToUpdate.customerAddressObservation);
        setCustomerOrigin(customerAddressToUpdate.customerOrigin);
      }
    }, [isOpen, customerAddressToUpdate]);

    const handleSubmit = async () => {
      if (isSubmitting) return; // Evita submissões múltiplas

      setIsSubmitting(true);

      if (CustomerPhone && CustomerName && CustomerNewAddress && CustomerOrigin) {
        try {
          const CustomerResponse = await api.patch(`customerAddress`, {
            customerUuid: customerAddressToUpdate.customerUuid,
            customerPhone: CustomerPhone,
            customerName: CustomerName,
            // customerPlaceId: CustomerNewAddress.placeId,
            // customerFormattedAddress: CustomerNewAddress.formattedAddress,
            customerAddress: CustomerAddress,
            customerAddressComplement: CustomerAddressComplement,
            customerAddressObservation: CustomerAddressObservation,
            customerOrigin: CustomerOrigin,
          });
          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            subsidiaryInfo: subsidiaryDataZustand.subsidiaryInfo.map(
              (info: any) =>
                info.subsidiaryInfoType === 1
                  ? {
                    ...info,
                    subsidiaryInfoValue: {
                      ...info.subsidiaryInfoValue,
                      Customers: CustomerResponse.data.customers.Customers,
                    },
                  }
                  : info
            ),
          });
          setCustomerInfoByOrder({
            customerName: CustomerName,
            customerAddress: CustomerAddress,
            //customerAddress: CustomerNewAddress.formattedAddress,
            customerAddressComplement: CustomerAddressComplement,
            customerAddressObservation: CustomerAddressObservation,
            customerPhone: CustomerPhone,
          });
          onRequestClose();
          // setCustomerNewAddress({
          //   placeId: "",
          //   formattedAddress: "",
          // });
          setCustomerAddress("");
          setCustomerAddressComplement("");
          setCustomerAddressObservation("");
          setCustomerName("");
          setMessageZustand("Cliente atualizado com sucesso!", "success");
        } catch (error) {
          setMessageZustand("Erro ao cadastrar o cliente!", "error");
        } finally {
          setIsSubmitting(false); // Libera a submissão novamente
        }
      } else {
        setMessageZustand("Preencha todos os campos obrigatórios.", "error");
        setIsSubmitting(false); // Libera a submissão em caso de erro
      }
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter" &&
        //CustomerNewAddress.placeId !== ""
        CustomerAddress !== "") {
        handleSubmit();
      } else if (event.key === "Escape") {
        onRequestClose();
        // setCustomerNewAddress({
        //   placeId: "",
        //   formattedAddress: "",
        // });
        setCustomerAddress("");
        setCustomerAddressComplement("");
        setCustomerAddressObservation("");
        setCustomerName("");
      } else if (
        event.key === "Tab" &&
        CustomerNewAddress.placeId !== "" &&
        CustomerPhone !== "" &&
        CustomerName !== "" &&
        CustomerAddressComplement === ""
      ) {
        event.preventDefault();
        customerAddressComplementInputRef.current?.focus();
      } else if (
        event.key === "Tab" &&
        CustomerNewAddress.placeId !== "" &&
        CustomerPhone !== "" &&
        CustomerName !== "" &&
        CustomerAddressComplement !== "" &&
        CustomerAddressObservation === ""
      ) {
        event.preventDefault();
        customerAddressObservationInputRef.current?.focus();
      } else if (
        event.key === "Tab" &&
        CustomerNewAddress.placeId !== "" &&
        CustomerPhone !== "" &&
        CustomerName !== "" &&
        CustomerAddressComplement !== "" &&
        CustomerAddressObservation !== "" &&
        CustomerOrigin === ""
      ) {
        event.preventDefault();
        customerOriginInputRef.current?.focus();
      }
    };
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={() => onRequestClose()}
        style={Styles.customStyles}
        contentLabel="Main Modal"
        ariaHideApp={false}
      >
        <Styles.ModalWrapper
          tabIndex={-1}
          ref={modalWrapperRef}
          onKeyDown={handleKeyPress}
        >
          <Styles.CloseButton
            onClick={() => {
              onRequestClose();
              setCustomerNewAddress({
                placeId: "",
                formattedAddress: "",
              });
              setCustomerAddressComplement("");
              setCustomerAddressObservation("");
              setCustomerName("");
            }}
          >
            &times;
          </Styles.CloseButton>
          <Styles.ModalContent>
            <Styles.ModalHeader
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
              <Styles.ModalTitle>Atualizar Endereço</Styles.ModalTitle>
              <Styles.ModalDescription>{`Atualize as informações do cliente e seu endereço de entrega.`}</Styles.ModalDescription>
            </Styles.ModalHeader>
            <Styles.ModalBody
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .backgroundColor
              }
            >
              <Styles.RowContainer>
                <Styles.FieldContainer widht="50%">
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      onKeyDown={handleKeyPress}
                      ref={customerPhoneInputRef}
                      placeholder=""
                      autoFocus={CustomerPhone === "" ? true : false}
                      value={CustomerPhone}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        setSearchValueInput(e.target.value);
                        setCustomerPhone(e.target.value);
                      }}
                    />
                    <label>Telefone do Cliente</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>
                <Styles.FieldContainer widht="50%">
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      onKeyDown={handleKeyPress}
                      autoFocus={CustomerPhone === "" ? false : true}
                      ref={customerNameInputRef}
                      placeholder=""
                      value={CustomerName}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerName(e.target.value)
                      }
                      onKeyPress={handleKeyPress}
                    />
                    <label>Nome do Cliente</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>
              </Styles.RowContainer>
              <Styles.RowContainer>
                <Styles.FieldContainer widht="70%">
                  {/* <Styles.AddressInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                    onKeyDown={handleKeyPress}
                  >
                    <AddressAutocomplete
                      initialAddress={customerAddressToUpdate.customerFormattedAddress}
                      setCustomerNewAddress={setCustomerNewAddress}
                      setError={setError}
                    />
                  </Styles.AddressInput> */}
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      placeholder=""
                      onKeyDown={handleKeyPress}
                      ref={customerAddressInputRef}
                      value={CustomerAddress}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerAddress(e.target.value)
                      }
                    />
                    <label>Endereço do Cliente</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>

                <Styles.FieldContainer widht="30%">
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      onKeyDown={handleKeyPress}
                      placeholder=""
                      ref={customerAddressComplementInputRef}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerAddressComplement(e.target.value)
                      }
                      value={CustomerAddressComplement}
                    />
                    <label>Complemento</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>
              </Styles.RowContainer>
              <Styles.RowContainer>
                <Styles.FieldContainer widht="50%">
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      placeholder=""
                      onKeyDown={handleKeyPress}
                      value={CustomerAddressObservation}
                      ref={customerAddressObservationInputRef}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerAddressObservation(e.target.value)
                      }
                    />
                    <label>Observações</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>
                <Styles.FieldContainer widht="50%">
                  <Styles.DropdownInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <select
                      ref={customerOriginInputRef}
                      onChange={(e) => {
                        setCustomerOrigin(e.target.value);
                      }}
                      value={CustomerOrigin}
                    >
                      <option value="directContact">Telefone</option>
                      <option value="externalApp">
                        Aplicativo externo (Ifood, Rappi...)
                      </option>
                      <option value="internalApp">
                        Aplicativo interno (Alfredo, Lucco)
                      </option>
                    </select>
                    <label>Origem do Cliente</label>
                  </Styles.DropdownInput>
                </Styles.FieldContainer>
              </Styles.RowContainer>
            </Styles.ModalBody>
            <Styles.ModalFooter
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <Styles.Button
                onClick={() => {
                  setCustomerInfoByOrder({
                    customerName: "",
                    customerAddress: "",
                    customerAddressComplement: "",
                    customerAddressObservation: "",
                    customerOrigin: "",
                    customerPhone: "",
                  });
                  // setCustomerNewAddress({
                  //   placeId: "",
                  //   formattedAddress: "",
                  // });
                  setCustomerAddress("");
                  setCustomerAddressComplement("");
                  setCustomerAddressObservation("");
                  setCustomerName("");
                  onRequestClose();
                }}
              >
                Cancelar
              </Styles.Button>
              <Styles.Button onClick={handleSubmit}>
                Atualizar Endereço
              </Styles.Button>
            </Styles.ModalFooter>
          </Styles.ModalContent>
        </Styles.ModalWrapper>
      </Modal>
    );
  };

export default UpdateCustomerAddressModal;
